import { LogOut01Icon } from '@langchain/untitled-ui-icons';
import { Button, LinearProgress } from '@mui/joy';

import { FC } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import Layout from '@/components/Layout';
import { useAuth } from '@/hooks/useAuth/useAuth';
import { useLogout } from '@/hooks/useLogout';

import AgentMarketplaceHeroCard from './AgentMarketplaceHeroCard';
// import MarketplaceButtons from './MarketplaceButtons';
import { useAgents } from './hooks/useAgents';

const AgentMarketplace: FC = () => {
  const { authed } = useAuth();
  const navigate = useNavigate();
  const logout = useLogout();
  const {
    data: agents,
    isLoading: isLoadingAgents,
    error: errorAgents,
  } = useAgents();

  const title = (
    <div className="flex flex-col items-center">
      <img className="w-[700px]" src="/img/agentmarketplace.png" />
      <span className="mb-8 text-2xl font-light text-secondary">
        Trade Agents and Ideas
      </span>
    </div>
  );

  if (isLoadingAgents) {
    return <LinearProgress />;
  }

  if (errorAgents) {
    return (
      <div>
        Error loading agents. Please refresh the page or try again later.
      </div>
    );
  }

  return (
    <>
      <div className="flex w-full flex-row items-center justify-end">
        {/* <MarketplaceButtons /> */}
      </div>
      {title}
      <div className="grid grid-cols-2 gap-4 overflow-y-auto">
        {agents.map((card) => {
          return (
            <div key={card.id} className="col-span-1 max-w-[450px]">
              <NavLink to={`/${card.id}`}>
                <AgentMarketplaceHeroCard agent={card} />
              </NavLink>
            </div>
          );
        })}
      </div>
      <div className="absolute bottom-4 right-4">
        {authed && (
          <Button
            className="flex items-center gap-4 rounded-md px-4 py-4"
            onClick={async () => {
              await logout();
              navigate(0);
            }}
            color="neutral"
            variant="outlined"
          >
            <LogOut01Icon className="h-4 w-4 text-secondary" />
            <span className="text-sm text-secondary">Log out</span>
          </Button>
        )}
      </div>
    </>
  );
};

const MarketplacePage = () => {
  return (
    <ErrorBoundary
      fallback={() => (
        <div className="flex h-[100vh] flex-col">
          <div className="mx-5 my-auto rounded-md border-2 border-error p-4 text-center text-lg text-error">
            Failed to get marketplace. Refresh the page to try again.
          </div>
        </div>
      )}
    >
      <Layout.Root>
        <div className="flex h-[calc(100vh)] flex-col items-center gap-6 overflow-hidden overflow-x-auto px-10 py-4">
          <AgentMarketplace />
        </div>
      </Layout.Root>
    </ErrorBoundary>
  );
};

export default MarketplacePage;
